<onyx-modal
  variant="center"
  [heading]="`${I18N}.${data.mode}Document`"
  [close$]="close$"
  (closeModal)="dialogRef.close($event)"
>
  <form [formGroup]="data.documents" [onyxAutoFocus]="data.mode">
    @let controls = data.documents.controls;
    <onyx-dropdown
      [formControl]="controls.type"
      label="labels.documentType"
      [options]="documentTypes$ | async"
    ></onyx-dropdown>

    <onyx-datepicker
      [formControl]="controls.expirationDate"
      label="labels.expirationDate"
      [showIndefinite]="true"
      [yearsRange]="{ past: 0, future: 20 }"
      [warningTypes]="['pastDate']"
    ></onyx-datepicker>

    <onyx-upload
      [formControl]="controls.scan"
      label="labels.documentScan"
    ></onyx-upload>
  </form>

  <ng-container bottomRightOptions>
    <onyx-button variant="outlined" (click)="cancel()">
      {{ 'labels.cancel' | translate }}
    </onyx-button>

    <onyx-button (click)="submit()">
      {{
        `labels.${data.mode === OnyxFormMode.ADD ? 'add' : 'saveChanges'}`
          | translate
      }}
    </onyx-button>
  </ng-container>
</onyx-modal>
